module.exports = __webpack_public_path__ + "img/img_prof_seller.e95dbb54.png";